var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGovFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M21 20.25h-1V19q0-1.001-1-1h-.25v-7H19q1 0 1-1V7.44a1 1 0 0 0-.553-.894l-6.776-3.388a1.5 1.5 0 0 0-1.342 0L4.553 6.546A1 1 0 0 0 4 7.44V10q0 1 1 1h.25v7H5q-1-.001-1 1v1.25H3a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5m-9-14.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M6.75 18v-7h2.5v7zm4 0v-7h2.5v7zm4 0v-7h2.5v7z"
})));
export default SvgGovFill;